/**
 * store
 */

let getStore;

if (process.env.NODE_ENV === 'development') {
  getStore = require('./index.dev').default;
} else {
  getStore = require('./index.prod').default;
}

const store = getStore();

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js